/**
 * Shown in the password tooltips on both the signup and password-reset forms.
 * These are Cognito's default password policy rules — if the pool's policy is
 * changed under Authentication methods → Password policy, update this list.
 */
export const PASSWORD_RULES = [
  'At least 8 characters',
  'An uppercase letter',
  'A lowercase letter',
  'A number',
  'A special character (e.g. ! ? # $)',
];
